import {createSlice} from '@reduxjs/toolkit';
import {getQuery} from '../../../../../../../scripts/util/getQuery';

export const providerItemsSlice = createSlice({
    name: 'providers',
    initialState: {
      isFetching: false,
      data: {}
    },
    reducers: {
      getProviderItems: state => {
        state.isFetching = true;
      },
      getProviderItemsSuccess: (state, action) => {
        state.isFetching = false;
        state.data = action.payload;
      }
    }
  });
  
  export default providerItemsSlice.reducer;
  
  const {
    getProviderItems,
    getProviderItemsSuccess
  } = providerItemsSlice.actions;
  
  const getProviderItemsData = (params, signal) => {
    const {
      keyword,
      miles,
      latitude,
      longitude,
      specIds,
      locationIds,
      start,
      size,
      sort,
      affiliation,
      gender,
      language,
      newPatients,
      openScheduling
    } = params;

    let reqParams = {};
    if (keyword) {
      reqParams.keyword = keyword;
    }
    if (miles) {
      reqParams.miles = miles;
    }
    if (latitude && longitude) {
      reqParams.location = `${latitude}|${longitude}`;
    }
    if (specIds && specIds.length > 0) {
      reqParams.specIds = params.specIds.join('|');
    }
    if (locationIds) {
      reqParams.locationIds = params.locationIds;
    }
    if (affiliation) {
      reqParams.affiliationId = affiliation;
    }
    if (gender) {
      reqParams.genderId = gender;
    }
    if (language) {
      reqParams.languageId = language;
    }
    if (newPatients) {
      reqParams.newPatients = '1';
    }
    if (openScheduling) {
      reqParams.openScheduling = '1';
    }
    reqParams.start = start;
    reqParams.size = size;
    reqParams.sort = sort;
      
    return async (dispatch) => {
      dispatch(getProviderItems());
      return fetch(new Request(`/api/search/provider/get?${getQuery(reqParams)}`, {
          method: 'GET',
          signal: signal
      }))
      .then(response => response.json()).then(json => {
          dispatch(getProviderItemsSuccess(json));
      });
    };
  };
  
  export { getProviderItemsData };